import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import { GetTotalWashingCountByRangeDayResponse } from '@/types/apis/washingCount/GetTotalWashingCountByRangeDayResponse'

import {
  ContainerTable,
  DataCellWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '../styles'

type Props = {
  responseTotalWashingCount: GetTotalWashingCountByRangeDayResponse
  responseTotalWashingCountLoading?: boolean
}

const TotalCustomerLaundryByRangeDayTable = ({
  responseTotalWashingCount,
  responseTotalWashingCountLoading,
}: Props) => {
  const { t } = useTranslation()
  const dataSource = responseTotalWashingCount.items

  return (
    <ContainerTable>
      <Spin spinning={responseTotalWashingCountLoading}>
        <TableWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <tr>
                  <HeaderCelDate>{t('components.pages.washingCount.listReport.table.date')}</HeaderCelDate>
                  {dataSource?.map((item, index) => (
                    <HeaderCellWrapper key={index}>{item.name}</HeaderCellWrapper>
                  ))}

                  <HeaderCellWrapper>{t('components.pages.washingCount.listReport.table.total')}</HeaderCellWrapper>
                </tr>
                {dataSource.length ? (
                  <tr>
                    {dataSource?.map((item, index) => (
                      <DataCellWrapper key={index}>{item.count}</DataCellWrapper>
                    ))}
                    <DataCellWrapper>{responseTotalWashingCount.totalCount}</DataCellWrapper>
                  </tr>
                ) : null}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
TotalCustomerLaundryByRangeDayTable.displayName = 'TotalCustomerLaundryByRangeDayTable'
export default TotalCustomerLaundryByRangeDayTable
